/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ValidateSessionRequest} from '@cash-web/protos/squareup/client/flipper/flipper.pb'
import {ValidateSessionResponse} from '@cash-web/protos/squareup/client/flipper/flipper.pb'


export const validateSession = (request: ValidateSessionRequest, options?: CashRequestOptions) => post<ValidateSessionRequest, ValidateSessionResponse>("/2.0/cash/validate-session", request, {...options, rejectOnError: true })